import React from 'react';
import { Modal, Form, Select, DatePicker, Input, Button, Spin, InputNumber } from 'antd';
import { ProjectDto, AssignContractorToProjectCommand } from 'api/models';
import { useTranslation } from 'react-i18next';

interface AssignProjectModalProps {
  visible: boolean;
  onCancel: () => void;
  onSubmit: (values: AssignContractorToProjectCommand) => void;
  projects: ProjectDto[];
  loading: boolean;
}

export const AssignProjectModal: React.FC<AssignProjectModalProps> = ({
  visible,
  onCancel,
  onSubmit,
  projects,
  loading,
}) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  return (
    <Modal
      title={t('contractors:assign-project', 'Assign Project')}
      open={visible}
      onCancel={onCancel}
      footer={null}
    >
      {loading ? (
        <Spin size="large" />
      ) : (
        <Form form={form} onFinish={onSubmit} layout="vertical">
          <Form.Item name="projectId" label={t('projects:select', 'Select Project')} rules={[{ required: true }]}>
            <Select placeholder={t('projects:select-placeholder', 'Select a project')}>
              {projects.map(project => (
                <Select.Option key={project.id} value={project.id}>
                  {project.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            name="investmentValue"
            label={t('contractors:investment-value', 'Investment Value')}
            rules={[{ required: true, message: t('contractors:investment-required', 'Investment value is required') }]}
          >
            <InputNumber
              style={{ width: '100%' }}
              min={0}
              precision={2}
              prefix="€"
              placeholder={t('contractors:investment-placeholder', 'Enter investment value')}
            />
          </Form.Item>

          <Form.Item
            name="startDate"
            label={t('contractors:start-date', 'Start Date')}
            rules={[{ required: true }]}
          >
            <DatePicker className="w-full" />
          </Form.Item>

          <Form.Item name="endDate" label={t('contractors:end-date', 'End Date')}>
            <DatePicker className="w-full" />
          </Form.Item>

          <Form.Item name="description" label={t('contractors:description', 'Description')}>
            <Input.TextArea />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit">
              {t('contractors:assign', 'Assign')}
            </Button>
          </Form.Item>
        </Form>
      )}
    </Modal>
  );
};